import React from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/MasterData/Channel/add';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { v3_add_channel, v3_add_event_type } from '../../../actions/v3/masterData';

const AddCategory = (props) => {
    const onSubmit = (model) => {
        v3_add_channel(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.listChannelMasterData.url);
            } else {
                toast.error(res.error);
            }
        });
    };

    return (
        <React.Fragment>
            <Layout title="Add Channel">
                <Form
                    title="Add Channel"
                    onSubmit={onSubmit}
                    buttonName="Create Channel"
                />
            </Layout>
        </React.Fragment>
    );
};

export default AddCategory;
